import { useState } from "react";
import { UrlObject } from "url";
import { classes } from "lib/actions/util";
import Dropdown from "components/elements/Dropdown/Dropdown";
import MoreSvg from "components/icons/24/actions/more.svg";
import { CrumbComponent } from "./crumb-component";
import { BreadcrumbMenuContext } from "./BreadcrumbLink";

/**
 * The "…" button that stands in for the crumbs folded away on a narrow window,
 * listing them in trail order when opened.
 */
export default function BreadcrumbFoldMenu(p: {
  crumbs: {
    component: CrumbComponent;
    segments: string[];
    params: string[];
    href: UrlObject;
  }[];
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      variant="simple"
      className="shrink-0"
      placement="bottom-start"
      dropdownWidth="max-content"
      dropdownMaxHeight="none"
      isOpen={isOpen}
      toggleOpen={() => setIsOpen((isOpen) => !isOpen)}
      buttonContent={
        <div
          aria-label="Show hidden levels"
          className={classes(
            "flex h-7 w-7 items-center justify-center rounded-md text-gray-600 hover:bg-gray-50",
            isOpen && "bg-gray-200 hover:bg-gray-200",
          )}
        >
          <MoreSvg className="w-5 rotate-90" />
        </div>
      }
      dropdownContent={
        <div
          className="flex flex-col gap-0.5 p-1.5 text-sm"
          onClick={() => setIsOpen(false)}
        >
          {p.crumbs.map((crumb, i) => (
            <BreadcrumbMenuContext.Provider
              key={crumb.href.pathname}
              value={{ isInMenu: true, hasLevelChevron: i > 0 }}
            >
              <crumb.component
                segments={crumb.segments}
                params={crumb.params}
                href={crumb.href}
              />
            </BreadcrumbMenuContext.Provider>
          ))}
        </div>
      }
    />
  );
}
